module.exports = __webpack_public_path__ + "static/media/SchoolCosSchoolReceive3.67c633cb.png";